module.exports = __webpack_public_path__ + "img/@logo_hdc.79881d1c.png";